/* Peak Labs - customer reviews (#/reviews), COA on request (#/coa) and the
   product-page COA note. Exposes window.ReviewsPage, window.CoaRequestPage and
   window.CoaRequestNote for the precompiled SPA routers. Plain React.createElement,
   no JSX, no Babel. React is only touched at render time, so this file may load
   before or after the React bundle. All classes are namespaced .rv-* (CSS in
   peak-labs-reviews.css). The form posts to the tracking worker and the passcode
   inbox reads reviews back. Reviews go to the passcode inbox and may be published on
   the site where the customer left the share switch on (publishOk, defaults to on).
   If published, the rating, the words, the photo (if any) and the given name (or
   Anonymous) are shown. Phone numbers and e-mail addresses are never shown on the site. */
(function () {
  if (typeof window === "undefined") return;

  var ENDPOINT = "https://peaklabs-tracking.peaklabs.workers.dev/api/review";
  var WA_NUMBER = "";
  var MIN_TEXT = 10;
  var MAX_TEXT = 4000;
  var MAX_EDGE = 1280;
  var JPEG_Q = 0.82;
  var MAX_B64 = 2200000; /* ~1.6 MB decoded */
  var CAPTIONS = ["", "Poor", "Fair", "Good", "Very good", "Excellent"];

  function h() { return React.createElement.apply(React, arguments); }
  function assets() { return window.PEAK_ASSETS || {}; }
  function reducedMotion() {
    try { return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); }
    catch (e) { return false; }
  }
  function waHref(text) { return "https://wa.me/" + WA_NUMBER + "?text=" + encodeURIComponent(text); }
  function goTo(onNavigate, path) {
    return function (e) {
      if (e && e.preventDefault) e.preventDefault();
      if (typeof onNavigate === "function") onNavigate(path);
      else window.location.hash = "#" + path;
    };
  }

  /* Same rules as the storefront "request a peptide" modal (plNormPhone): returns the
     E.164 string or "" when the number cannot be a real one. UAE first: 05x, 971, +971. */
  function normPhone(v) {
    var s = String(v || "").replace(/[ ().-]/g, "");
    if (s.slice(0, 2) === "00") s = "+" + s.slice(2);
    if (!/^\+?[0-9]+$/.test(s)) return "";
    var plus = s[0] === "+", d = plus ? s.slice(1) : s;
    var uae = function (n) { return /^5[024568][0-9]{7}$/.test(n) || /^[234679][0-9]{7}$/.test(n); };
    if (d.slice(0, 3) === "971") { var n = d.slice(3); return uae(n) ? "+971" + n : ""; }
    if (plus) return /^[1-9][0-9]{7,14}$/.test(d) ? "+" + d : "";
    if (d[0] === "0") { var m = d.slice(1); return uae(m) ? "+971" + m : ""; }
    return /^5[024568][0-9]{7}$/.test(d) ? "+971" + d : "";
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || "").trim()); }

  /* Datalist suggestions from whatever catalogue globals the page has. */
  function productSuggestions() {
    var out = [], seen = {};
    function add(label) {
      label = String(label || "").replace(/\s+/g, " ").trim();
      if (!label || seen[label.toLowerCase()]) return;
      seen[label.toLowerCase()] = 1;
      out.push(label);
    }
    function each(list, fn) { if (Array.isArray(list)) for (var i = 0; i < list.length; i++) if (list[i]) fn(list[i]); }
    each(window.SHOPIFY_CATALOGUE, function (p) { add(p.name + (p.dose ? " " + p.dose : "")); });
    each(window.PENS, function (p) { add((p.name || "") + (p.dose ? " " + p.dose : "") + " pen"); });
    each(window.SPRAYS || window.PL_SPRAYS, function (p) { add((p.name || "") + (p.mg ? " " + p.mg + " mg" : "") + " nasal spray"); });
    return out;
  }

  /* Client-side downscale: longest edge <= 1280 px, JPEG q0.82, re-tried smaller if the
     result is still over the size cap. Resolves { dataUrl, type, bytes }. */
  function shrinkImage(file) {
    return new Promise(function (resolve, reject) {
      if (!file) return reject("Please choose a photo.");
      var isImage = /^image\//i.test(file.type || "") || /\.(heic|heif|jpe?g|png|webp|gif|avif)$/i.test(file.name || "");
      if (!isImage) return reject("Please choose an image file (JPG, PNG or WEBP).");
      var url;
      try { url = URL.createObjectURL(file); } catch (e) { return reject("That photo could not be read."); }
      var img = new Image();
      img.onload = function () {
        try { URL.revokeObjectURL(url); } catch (e) {}
        var w = img.naturalWidth || img.width, hh = img.naturalHeight || img.height;
        if (!w || !hh) return reject("That photo could not be read.");
        var attempts = [[MAX_EDGE, JPEG_Q], [1024, 0.72], [800, 0.6]];
        for (var i = 0; i < attempts.length; i++) {
          var edge = attempts[i][0], q = attempts[i][1];
          var scale = Math.min(1, edge / Math.max(w, hh));
          var cw = Math.max(1, Math.round(w * scale)), ch = Math.max(1, Math.round(hh * scale));
          var c = document.createElement("canvas");
          c.width = cw; c.height = ch;
          var ctx = c.getContext("2d");
          if (!ctx) return reject("Your browser could not process the photo.");
          ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, cw, ch);
          ctx.drawImage(img, 0, 0, cw, ch);
          var dataUrl;
          try { dataUrl = c.toDataURL("image/jpeg", q); } catch (e) { return reject("Your browser could not process the photo."); }
          var b64 = dataUrl.split(",")[1] || "";
          if (b64.length <= MAX_B64) return resolve({ dataUrl: dataUrl, type: "image/jpeg", bytes: Math.round(b64.length * 0.75), width: cw, height: ch });
        }
        reject("That photo is too large even after resizing. Please try a smaller one.");
      };
      img.onerror = function () {
        try { URL.revokeObjectURL(url); } catch (e) {}
        reject("That photo could not be read. If it is a HEIC file, please save it as JPG first.");
      };
      img.src = url;
    });
  }

  /* ---------- icons (inline so this file has no dependency on the bundle) ---------- */
  var ICON = {
    star: function () { return h("svg", { viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false" }, h("path", { d: "M12 2.6l2.83 6.1 6.67.72-4.95 4.53 1.36 6.57L12 17.2l-5.91 3.32 1.36-6.57L2.5 9.42l6.67-.72z" })); },
    lock: function () { return h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false" }, h("rect", { x: 4, y: 10.5, width: 16, height: 10, rx: 2 }), h("path", { d: "M8 10.5V7.5a4 4 0 0 1 8 0v3" })); },
    shield: function () { return h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false" }, h("path", { d: "M12 2.8l7.5 2.9v6.1c0 4.6-3.2 8.3-7.5 9.4-4.3-1.1-7.5-4.8-7.5-9.4V5.7z" }), h("path", { d: "M8.8 12.1l2.1 2.1 4.3-4.4" })); },
    camera: function () { return h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false" }, h("path", { d: "M4 8.5h3.2l1.5-2.5h6.6l1.5 2.5H20v10H4z" }), h("circle", { cx: 12, cy: 13.3, r: 3.2 })); },
    close: function () { return h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", "aria-hidden": "true", focusable: "false" }, h("path", { d: "M6 6l12 12M18 6L6 18" })); },
    check: function () { return h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false" }, h("path", { d: "M5 12.5l4.5 4.5L19 7.5" })); },
    alert: function () { return h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", "aria-hidden": "true", focusable: "false" }, h("circle", { cx: 12, cy: 12, r: 9 }), h("path", { d: "M12 7.5v5.5M12 16.4v.2" })); },
    arrow: function () { return h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false" }, h("path", { d: "M5 12h14M13 6l6 6-6 6" })); },
    whatsapp: function () { return h("svg", { viewBox: "0 0 32 32", fill: "currentColor", "aria-hidden": "true", focusable: "false" }, h("path", { d: "M16 2.67C8.64 2.67 2.67 8.64 2.67 16c0 2.35.61 4.65 1.78 6.68L2.67 29.33l6.83-1.75A13.27 13.27 0 0 0 16 29.33c7.36 0 13.33-5.97 13.33-13.33S23.36 2.67 16 2.67zm0 24a10.6 10.6 0 0 1-5.72-1.66l-.4-.24-4.05 1.04 1.08-3.96-.26-.41A10.63 10.63 0 0 1 5.33 16C5.33 10.12 10.12 5.33 16 5.33S26.67 10.12 26.67 16 21.88 26.67 16 26.67zm5.85-7.93l-2.3-1.15c-.34-.17-.74-.13-1.05.1l-1.4.96a8.49 8.49 0 0 1-3.74-3.74l.96-1.4c.23-.31.27-.71.1-1.05l-1.15-2.3a.92.92 0 0 0-1.15-.45 4.05 4.05 0 0 0-2.45 3.71c0 5.05 4.1 9.15 9.15 9.15a4.05 4.05 0 0 0 3.71-2.45.92.92 0 0 0-.45-1.15z" })); }
  };

  /* ---------- small building blocks ---------- */
  function Reveal(props) {
    return h("div", { className: "rv-reveal " + (props.className || ""), style: { "--rv-i": props.i || 0 } }, props.children);
  }

  function Field(props) {
    var errId = props.id + "-err", hintId = props.id + "-hint";
    return h(Reveal, { i: props.i, className: "rv-field" },
      h("label", { className: "rv-label", htmlFor: props.id },
        h("span", null, props.label),
        props.right ? props.right : (props.optional ? h("span", { className: "rv-opt" }, "Optional") : null)),
      props.children,
      props.hint ? h("p", { className: "rv-hint", id: hintId }, props.hint) : null,
      h("p", { className: "rv-error", id: errId, "aria-live": "polite" },
        props.error ? [h(ICON.alert, { key: "i" }), h("span", { key: "t" }, props.error)] : null));
  }

  function describedBy(id, hasHint, hasError) {
    var ids = [];
    if (hasHint) ids.push(id + "-hint");
    if (hasError) ids.push(id + "-err");
    return ids.length ? ids.join(" ") : undefined;
  }

  /* Star rating: radio-group semantics, roving tabindex, arrow keys, hover preview. */
  function StarRating(props) {
    var hover = React.useState(0), hov = hover[0], setHov = hover[1];
    var value = props.value || 0;
    var refs = React.useRef([]);
    function pick(n) { props.onChange(n); }
    function onKey(e, n) {
      var next = null;
      if (e.key === "ArrowRight" || e.key === "ArrowUp") next = Math.min(5, (value || n) + 1);
      else if (e.key === "ArrowLeft" || e.key === "ArrowDown") next = Math.max(1, (value || n) - 1);
      else if (e.key === "Home") next = 1;
      else if (e.key === "End") next = 5;
      else if (e.key === " " || e.key === "Enter") next = n;
      if (next === null) return;
      e.preventDefault();
      pick(next);
      var el = refs.current[next - 1];
      if (el && el.focus) el.focus();
    }
    var lit = hov || value;
    var stars = [];
    for (var i = 1; i <= 5; i++) {
      (function (n) {
        stars.push(h("button", {
          key: n, type: "button", role: "radio", className: "rv-star" + (n <= lit ? " is-lit" : ""),
          "aria-checked": value === n ? "true" : "false",
          "aria-label": n + (n === 1 ? " star" : " stars") + (CAPTIONS[n] ? ", " + CAPTIONS[n] : ""),
          tabIndex: (value ? value === n : n === 1) ? 0 : -1,
          ref: function (el) { refs.current[n - 1] = el; },
          onClick: function () { pick(n); },
          onKeyDown: function (e) { onKey(e, n); },
          onMouseEnter: function () { setHov(n); },
          onMouseLeave: function () { setHov(0); },
          onFocus: function () { setHov(0); },
          onBlur: props.onBlur
        }, h(ICON.star)));
      })(i);
    }
    var captionN = hov || value;
    return h("div", { className: "rv-stars", role: "radiogroup", "aria-label": "Your rating", "aria-required": "true", "aria-invalid": props.invalid ? "true" : undefined, "aria-describedby": props.describedBy, id: props.id, ref: props.groupRef },
      stars,
      h("span", { className: "rv-star-caption" + (value ? " is-set" : ""), "aria-hidden": "true" }, captionN ? CAPTIONS[captionN] : "Tap to rate"));
  }

  function Media(props) {
    /* props: wide, tall, alt, className, emptyClass, position */
    var broken = React.useState(false), isBroken = broken[0], setBroken = broken[1];
    var wide = props.wide || props.tall, tall = props.tall || props.wide;
    var empty = !wide || isBroken;
    return h("div", { className: props.className + (empty ? " " + props.emptyClass : ""), "aria-hidden": "true" },
      empty ? null : h("picture", null,
        (props.tall && props.wide && props.tall !== props.wide) ? h("source", { media: "(max-width: 820px)", srcSet: tall }) : null,
        h("img", { src: wide, alt: "", loading: props.loading || "eager", decoding: "async", onError: function () { setBroken(true); } })));
  }

  /* ---------- hero ---------- */
  function Hero() {
    var a = assets();
    return h("section", { className: "rv-hero" },
      h("div", { className: "rv-wrap rv-hero-grid" },
        h("div", null,
          h(Reveal, { i: 0 }, h("p", { className: "rv-eyebrow" }, "Peak Labs · Customer reviews")),
          h(Reveal, { i: 1 }, h("h1", null, "Tell us how it went. ", h("b", null, "We read every one."))),
          h(Reveal, { i: 2 }, h("p", { className: "rv-lede" }, "Your review goes straight to the Peak Labs team, and with your permission we may share it on the site. Your phone number and e-mail always stay private.")),
          h(Reveal, { i: 3 },
            h("ul", { className: "rv-points" },
              h("li", null, "Read by the team"),
              h("li", null, "Takes two minutes"),
              h("li", null, "Photos welcome")))),
        h(Reveal, { i: 1 }, h(Media, { className: "rv-media", emptyClass: "rv-media--empty", wide: a.reviewsHero, tall: a.reviewsHeroTall }))));
  }

  /* ---------- success ---------- */
  function Thanks(props) {
    var a = assets();
    var headRef = React.useRef(null);
    React.useEffect(function () {
      try { window.scrollTo({ top: 0, behavior: reducedMotion() ? "auto" : "smooth" }); } catch (e) { try { window.scrollTo(0, 0); } catch (e2) {} }
      var t = setTimeout(function () { if (headRef.current && headRef.current.focus) headRef.current.focus({ preventScroll: true }); }, 80);
      return function () { clearTimeout(t); };
    }, []);
    return h("section", { className: "rv-section" },
      h("div", { className: "rv-wrap" },
        h("div", { className: "rv-thanks", role: "status", "aria-live": "polite" },
          h(Media, { className: "rv-thanks-media", emptyClass: "rv-thanks-media--empty", wide: a.reviewsThanks }),
          h("div", { className: "rv-thanks-body" },
            h("div", { className: "rv-thanks-check" }, h(ICON.check)),
            h("h2", { ref: headRef, tabIndex: -1 }, "Thank you."),
            h("p", null, "Your review is with the Peak Labs team. Thank you for taking the time."),
            h("div", { className: "rv-actions" },
              h("a", { className: "rv-btn", href: "#/", onClick: goTo(props.onNavigate, "/") }, "Back to the store", h(ICON.arrow)))))));
  }

  /* ---------- the form ---------- */
  var ORDER = ["rating", "name", "phone", "email", "order", "product", "text"];

  function ReviewForm(props) {
    var st = React.useState({ rating: 0, name: "", anonymous: false, publishOk: true, phone: "", email: "", order: "", product: "", text: "", website: "" });
    var v = st[0], setV = st[1];
    var er = React.useState({}), errors = er[0], setErrors = er[1];
    var ph = React.useState(null), photo = ph[0], setPhoto = ph[1];         /* { dataUrl, bytes } */
    var pe = React.useState(""), photoErr = pe[0], setPhotoErr = pe[1];
    var pb = React.useState(false), photoBusy = pb[0], setPhotoBusy = pb[1];
    var dz = React.useState(false), dragOver = dz[0], setDragOver = dz[1];
    var sb = React.useState("idle"), status = sb[0], setStatus = sb[1];    /* idle | sending */
    var fe = React.useState(""), formErr = fe[0], setFormErr = fe[1];
    var refs = React.useRef({});
    var fileRef = React.useRef(null);
    var suggestions = React.useMemo(productSuggestions, []);

    function setField(k, val) {
      setV(function (p) { var n = {}; for (var key in p) n[key] = p[key]; n[k] = val; return n; });
      /* Errors only appear on blur or submit; once one is showing, fixing the field clears it. */
      if (errors[k]) {
        var next = {}; for (var key in v) next[key] = v[key]; next[k] = val;
        var msg = validateOne(k, next);
        if (!msg) setErrors(function (p) { var n = {}; for (var key in p) if (key !== k) n[key] = p[key]; return n; });
      }
    }
    function validateOne(k, s) {
      switch (k) {
        case "rating": return s.rating >= 1 && s.rating <= 5 ? "" : "Please choose a star rating.";
        case "name": return s.anonymous || s.name.trim() ? "" : "Please add your name, or switch on “Post anonymously”.";
        case "phone":
          if (!s.phone.trim()) return "Please add your phone number so we can confirm the order.";
          return normPhone(s.phone) ? "" : "That number does not look right. Try 050 123 4567 or +971 50 123 4567.";
        case "email": return !s.email.trim() || validEmail(s.email) ? "" : "That e-mail address does not look right.";
        case "order": return s.order.trim().length <= 40 ? "" : "Order numbers are shorter than that.";
        case "product": return s.product.trim().length <= 160 ? "" : "Please keep this under 160 characters.";
        case "text":
          var t = s.text.trim();
          if (t.length < MIN_TEXT) return "Please write at least " + MIN_TEXT + " characters.";
          if (t.length > MAX_TEXT) return "Please keep your review under " + MAX_TEXT + " characters.";
          return "";
      }
      return "";
    }
    function blur(k) {
      return function () {
        var msg = validateOne(k, v);
        setErrors(function (p) { var n = {}; for (var key in p) n[key] = p[key]; if (msg) n[k] = msg; else delete n[k]; return n; });
        if (k === "phone" && !msg) { var e164 = normPhone(v.phone); if (e164) setField("phone", e164); }
        if (k === "email" && !msg) setField("email", v.email.trim().toLowerCase());
      };
    }
    function validateAll() {
      var all = {};
      for (var i = 0; i < ORDER.length; i++) { var m = validateOne(ORDER[i], v); if (m) all[ORDER[i]] = m; }
      return all;
    }
    function focusFirst(all) {
      for (var i = 0; i < ORDER.length; i++) {
        if (all[ORDER[i]]) {
          var el = refs.current[ORDER[i]];
          if (el) {
            if (ORDER[i] === "rating") { var b = el.querySelector && el.querySelector("[tabindex='0']"); if (b) el = b; }
            try { el.focus({ preventScroll: true }); el.scrollIntoView({ block: "center", behavior: reducedMotion() ? "auto" : "smooth" }); } catch (e) { try { el.focus(); } catch (e2) {} }
          }
          return;
        }
      }
    }

    function onFiles(files) {
      var f = files && files[0];
      if (!f) return;
      setPhotoErr(""); setPhotoBusy(true);
      shrinkImage(f).then(function (res) { setPhoto(res); setPhotoBusy(false); },
        function (msg) { setPhoto(null); setPhotoErr(String(msg)); setPhotoBusy(false); });
    }
    function removePhoto() {
      setPhoto(null); setPhotoErr("");
      if (fileRef.current) { try { fileRef.current.value = ""; } catch (e) {} fileRef.current.focus(); }
    }

    function submit(e) {
      e.preventDefault();
      if (status === "sending") return;
      setFormErr("");
      var all = validateAll();
      setErrors(all);
      if (Object.keys(all).length) { focusFirst(all); return; }
      if (photoBusy) { setFormErr("Your photo is still being prepared. One moment."); return; }
      var payload = {
        rating: v.rating,
        name: v.anonymous ? "" : v.name.trim(),
        anonymous: !!v.anonymous,
        publishOk: !!v.publishOk,
        phone: normPhone(v.phone),
        email: v.email.trim().toLowerCase(),
        orderNumber: v.order.trim(),
        product: v.product.trim(),
        text: v.text.trim(),
        photo: photo ? photo.dataUrl : "",
        website: v.website,
        page: (window.location.href || "").split("#")[0]
      };
      setStatus("sending");
      var ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 30000) : null;
      fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }).then(function (data) { return { status: r.status, data: data }; }); })
        .then(function (res) {
          if (timer) clearTimeout(timer);
          setStatus("idle");
          if (res.data && res.data.ok) { props.onDone(); return; }
          var msg = (res.data && res.data.error) || "Something went wrong on our side. Please try again in a moment.";
          var field = res.data && res.data.field;
          if (field && ORDER.indexOf(field) >= 0) {
            var one = {}; one[field] = msg; setErrors(one); focusFirst(one);
          } else if (field === "photo") {
            setPhotoErr(msg);
          } else {
            setFormErr(msg);
          }
        })
        .catch(function () {
          if (timer) clearTimeout(timer);
          setStatus("idle");
          setFormErr("We could not reach our server. Please check your connection and try again, or email support@peaklabs.me.");
        });
    }

    var count = v.text.length;
    var countEl = h("span", { className: "rv-count" + (count > MAX_TEXT ? " rv-count--over" : ""), "aria-live": "off" }, count + " / " + MAX_TEXT);
    var i = 0;

    return h("form", { className: "rv-form", onSubmit: submit, noValidate: true, autoComplete: "on" },
      h("div", { className: "rv-card-head rv-reveal", style: { "--rv-i": i++ } },
        h("h2", null, "Your review"),
        h("p", null, "Every review is read by the Peak Labs team. With your permission, selected reviews may appear on the site.")),

      h(Field, { i: i++, id: "rv-rating", label: "Rating", error: errors.rating },
        h(StarRating, { id: "rv-rating-group", value: v.rating, invalid: !!errors.rating, describedBy: describedBy("rv-rating", false, !!errors.rating),
          onChange: function (n) { setField("rating", n); if (errors.rating) setErrors(function (p) { var q = {}; for (var k in p) if (k !== "rating") q[k] = p[k]; return q; }); },
          onBlur: function () {}, groupRef: function (el) { refs.current.rating = el; } })),

      h(Reveal, { i: i++, className: "rv-field" },
        h("button", { type: "button", className: "rv-switch", role: "switch", "aria-checked": v.anonymous ? "true" : "false",
          onClick: function () {
            var next = !v.anonymous;
            setV(function (p) { var n = {}; for (var key in p) n[key] = p[key]; n.anonymous = next; if (next) n.name = ""; return n; });
            if (next) setErrors(function (p) { var q = {}; for (var k in p) if (k !== "name") q[k] = p[k]; return q; });
          } },
          h("span", { className: "rv-switch-track", "aria-hidden": "true" }),
          h("span", null, "Post anonymously")),
        v.anonymous ? h("p", { className: "rv-hint" }, "Your name will not be attached to this review.") : null),

      h(Reveal, { i: i++, className: "rv-field" },
        h("button", { type: "button", className: "rv-switch", role: "switch", "aria-checked": v.publishOk ? "true" : "false",
          onClick: function () { setField("publishOk", !v.publishOk); } },
          h("span", { className: "rv-switch-track", "aria-hidden": "true" }),
          h("span", null, "Peak Labs may share this review on its website")),
        h("p", { className: "rv-hint" }, v.publishOk
          ? "If we share it, we show the rating, your words, the photo if you added one, and the name you gave here (or Anonymous). Your phone number and e-mail are never shown."
          : "Kept for the Peak Labs team only.")),

      v.anonymous ? null : h(Field, { i: i++, id: "rv-name", label: "Your name", error: errors.name },
        h("input", { id: "rv-name", className: "rv-input", type: "text", name: "name", autoComplete: "name", maxLength: 80, value: v.name,
          "aria-invalid": errors.name ? "true" : undefined, "aria-describedby": describedBy("rv-name", false, !!errors.name),
          ref: function (el) { refs.current.name = el; },
          onChange: function (e) { setField("name", e.target.value); }, onBlur: blur("name") })),

      h("div", { className: "rv-row" },
        h(Field, { i: i++, id: "rv-phone", label: "Phone number", hint: "Private. Never shown anywhere. We only use it to confirm your order.", error: errors.phone },
          h("input", { id: "rv-phone", className: "rv-input", type: "tel", name: "phone", inputMode: "tel", autoComplete: "tel", placeholder: "050 123 4567", maxLength: 24, value: v.phone,
            "aria-required": "true", "aria-invalid": errors.phone ? "true" : undefined, "aria-describedby": describedBy("rv-phone", true, !!errors.phone),
            ref: function (el) { refs.current.phone = el; },
            onChange: function (e) { setField("phone", e.target.value); }, onBlur: blur("phone") })),
        h(Field, { i: i++, id: "rv-email", label: "E-mail", optional: true, hint: "Private as well.", error: errors.email },
          h("input", { id: "rv-email", className: "rv-input", type: "email", name: "email", inputMode: "email", autoComplete: "email", maxLength: 160, value: v.email,
            "aria-invalid": errors.email ? "true" : undefined, "aria-describedby": describedBy("rv-email", true, !!errors.email),
            ref: function (el) { refs.current.email = el; },
            onChange: function (e) { setField("email", e.target.value); }, onBlur: blur("email") }))),

      h("div", { className: "rv-row" },
        h(Field, { i: i++, id: "rv-order", label: "Order number", optional: true, hint: "For example #1234. It helps us confirm it is a real order.", error: errors.order },
          h("input", { id: "rv-order", className: "rv-input", type: "text", name: "order", inputMode: "text", autoComplete: "off", placeholder: "#1234", maxLength: 40, value: v.order,
            "aria-invalid": errors.order ? "true" : undefined, "aria-describedby": describedBy("rv-order", true, !!errors.order),
            ref: function (el) { refs.current.order = el; },
            onChange: function (e) { setField("order", e.target.value); }, onBlur: blur("order") })),
        h(Field, { i: i++, id: "rv-product", label: "What you bought", optional: true, error: errors.product },
          h("input", { id: "rv-product", className: "rv-input", type: "text", name: "product", autoComplete: "off", list: suggestions.length ? "rv-product-list" : undefined, placeholder: "Product name", maxLength: 160, value: v.product,
            "aria-invalid": errors.product ? "true" : undefined, "aria-describedby": describedBy("rv-product", false, !!errors.product),
            ref: function (el) { refs.current.product = el; },
            onChange: function (e) { setField("product", e.target.value); }, onBlur: blur("product") }),
          suggestions.length ? h("datalist", { id: "rv-product-list" }, suggestions.map(function (s) { return h("option", { key: s, value: s }); })) : null)),

      h(Field, { i: i++, id: "rv-text", label: "Your review", right: countEl, hint: "At least " + MIN_TEXT + " characters. Tell us what you ordered, how the delivery went and what we could do better.", error: errors.text },
        h("textarea", { id: "rv-text", className: "rv-input", name: "text", rows: 6, maxLength: MAX_TEXT + 200, value: v.text,
          "aria-required": "true", "aria-invalid": errors.text ? "true" : undefined, "aria-describedby": describedBy("rv-text", true, !!errors.text),
          ref: function (el) { refs.current.text = el; },
          onChange: function (e) { setField("text", e.target.value); }, onBlur: blur("text") })),

      h(Field, { i: i++, id: "rv-photo", label: "Photo", optional: true, error: photoErr },
        h("div", { className: "rv-photo" + (dragOver ? " is-over" : ""),
          onDragOver: function (e) { e.preventDefault(); if (!dragOver) setDragOver(true); },
          onDragLeave: function () { setDragOver(false); },
          onDrop: function (e) { e.preventDefault(); setDragOver(false); onFiles(e.dataTransfer && e.dataTransfer.files); } },
          h("input", { id: "rv-photo", className: "rv-photo-input", type: "file", accept: "image/*", ref: fileRef, tabIndex: -1,
            "aria-describedby": describedBy("rv-photo", false, !!photoErr),
            onChange: function (e) { onFiles(e.target.files); } }),
          photo
            ? h("div", { className: "rv-photo-preview", key: photo.dataUrl.length },
                h("img", { src: photo.dataUrl, alt: "Your selected photo, " + photo.width + " by " + photo.height + " pixels" }),
                h("button", { type: "button", className: "rv-photo-remove", "aria-label": "Remove photo", onClick: removePhoto }, h(ICON.close)))
            : h("button", { type: "button", className: "rv-photo-btn", disabled: photoBusy, "aria-controls": "rv-photo",
                onClick: function () { if (fileRef.current) fileRef.current.click(); } },
                photoBusy ? h("span", { className: "rv-spin", style: { borderColor: "rgba(42,42,42,.2)", borderTopColor: "#2A2A2A" } }) : h(ICON.camera),
                photoBusy ? "Preparing" : "Add a photo"),
          h("p", { className: "rv-photo-text" }, photo
            ? "Ready, about " + Math.max(1, Math.round(photo.bytes / 1024)) + " KB. You can replace it by choosing another file."
            : "One image, JPG or PNG. It is resized on your device before it is sent."))),

      /* Honeypot: hidden from people, filled only by bots. */
      h("div", { className: "rv-hp", "aria-hidden": "true" },
        h("label", { htmlFor: "rv-website" }, "Website"),
        h("input", { id: "rv-website", type: "text", name: "website", tabIndex: -1, autoComplete: "off", value: v.website, onChange: function (e) { setField("website", e.target.value); } })),

      h(Reveal, { i: i++ },
        h("div", { className: "rv-consent" }, h(ICON.lock),
          h("p", null, "Your phone number and e-mail stay private. We only use them to confirm the order."))),

      h(Reveal, { i: i++, className: "rv-actions" },
        h("div", { className: "rv-form-error", role: "alert" }, formErr
          ? [h("span", { key: "m" }, formErr + " "),
             /^We could not reach/.test(formErr) ? h("a", { key: "w", href: waHref("Hello Peak Labs, I would like to leave a review."), target: "_blank", rel: "noopener noreferrer" }, "Open WhatsApp") : null]
          : null),
        h("button", { type: "submit", className: "rv-btn rv-btn--wide", disabled: status === "sending", "aria-busy": status === "sending" ? "true" : undefined },
          status === "sending" ? h("span", { className: "rv-spin", "aria-hidden": "true" }) : null,
          status === "sending" ? "Sending" : "Send my review"),
        h("p", { className: "rv-private" }, h(ICON.shield), "Your contact details stay private.")),

      h("p", { className: "rv-foot" }, "Peak Labs products are supplied for laboratory research use only."));
  }

  /* ---------- pages ---------- */
  window.ReviewsPage = function (props) {
    var d = React.useState(false), done = d[0], setDone = d[1];
    React.useEffect(function () {
      var prev = document.title;
      document.title = "Leave a Review · Peak Labs";
      return function () { if (document.title === "Leave a Review · Peak Labs") document.title = prev; };
    }, []);
    return h("main", { id: "main", tabIndex: -1, className: "rv" },
      done ? h(Thanks, { onNavigate: props && props.onNavigate })
           : [h(Hero, { key: "hero" }),
              h("section", { key: "form", className: "rv-section" },
                h("div", { className: "rv-wrap" },
                  h("div", { className: "rv-card" },
                    h(ReviewForm, { onDone: function () { setDone(true); }, onNavigate: props && props.onNavigate }))))]);
  };

  window.CoaRequestPage = function (props) {
    var a = assets();
    React.useEffect(function () {
      var prev = document.title;
      document.title = "Certificates of Analysis · Peak Labs";
      return function () { if (document.title === "Certificates of Analysis · Peak Labs") document.title = prev; };
    }, []);
    var onNavigate = props && props.onNavigate;
    return h("main", { id: "main", tabIndex: -1, className: "rv-coa" },
      h("div", { className: "rv-coa-card" },
        h(Media, { className: "rv-coa-media", emptyClass: "rv-coa-media--empty", wide: a.coaRequest }),
        h("div", { className: "rv-coa-body" },
          h("div", { className: "rv-coa-icon" }, h(ICON.shield)),
          h("p", { className: "rv-eyebrow" }, "Certificates of Analysis"),
          h("h1", null, "COA available on request"),
          h("p", null, "Every Peak Labs batch is third-party HPLC tested. Email support@peaklabs.me with the product name and the lot number printed on the vial label, and we will send you the certificate for that batch."),
          h("ul", { className: "rv-coa-include", "aria-label": "Include in your message" },
            h("li", null, "Product name"),
            h("li", null, "Lot number on the vial label")),
          h("div", { className: "rv-coa-actions" },
            h("a", { className: "rv-btn rv-btn--gold", href: waHref("Hello Peak Labs, please send the COA for: "), target: "_blank", rel: "noopener noreferrer" }, h(ICON.whatsapp), "Request on WhatsApp"),
            h("a", { className: "rv-link", href: "#/shop", onClick: goTo(onNavigate, "/shop") }, "Back to the shop", h(ICON.arrow))),
          h("p", { className: "rv-coa-fine" }, "For laboratory research use only."))));
  };

  window.CoaRequestNote = function (props) {
    var name = String((props && props.product) || "").trim();
    return h("div", { className: "rv-coa-note" },
      h(ICON.shield),
      h("span", null, h("strong", null, "COA available on request."), " Third-party HPLC tested, per batch."),
      h("a", { href: waHref("Hello Peak Labs, please send the COA for: " + (name || "")), target: "_blank", rel: "noopener noreferrer", "aria-label": "Request the certificate of analysis" + (name ? " for " + name : "") + " on WhatsApp" }, h(ICON.whatsapp), "Request on WhatsApp"));
  };

  /* If the SPA already rendered #/reviews or #/coa before this file arrived, ask it to repaint. */
  try {
    var hash = window.location.hash;
    if ((hash === "#/reviews" || hash === "#/coa") && typeof window.__peakStockRepaint === "function") window.__peakStockRepaint();
  } catch (e) {}
})();
